<template>
  <div class="mb-3" v-if="ddp.limit === 0 || ddp.limit < ddp.utilized">
    <alert :show-cta="false" showForMobile>
      <template slot="icon">
        <img
          src="@/assets/images/common/error-outline-white.svg"
          alt="Error Icon"
        />
      </template>
      <template slot="title">
        <b-icon-exclamation-triangle-fill class="icon-svg" />
        Available Limit Alert
      </template>
      <template slot="message">
        <div v-if="ddp.limit === 0">
          Your <b>Dynamic Drawing Power (DDP)</b> has been reduced to Zero.
          Please reach out to <b>{{ rmName }}</b> -
          <a :href="`mailto:${rmEmaill}`">{{ rmEmail }}</a> for more
          information.
        </div>
        <div v-else>
          Your Outstanding Balance is more than the current Dynamic Drawing
          Power (DDP) thus more invoices can be funded only post outstanding
          balance becomes less than the current DDP. Please reach out to
          <b>{{ rmName }}</b> -
          <a :href="`mailto:${rmEmail}`">{{ rmEmail }}</a> for more information.
        </div>
      </template>
    </alert>
  </div>
</template>
<script>
import Alert from '@/components/Alerts2/Alert'

export default {
  props: ['ddp'],
  computed: {
    rmName() {
      return this.ddp && this.ddp.rm && this.ddp.rm.name
    },
    rmEmail() {
      return this.ddp && this.ddp.rm && this.ddp.rm.email
    }
  },
  components: {
    Alert
  }
}
</script>
